import Swiper from 'swiper/bundle'
import { gsap } from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin)

/**
 * GoogleReviewsModule functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class GoogleReviewsModule {
  /**
     * Constructs a new GoogleReviewsModule instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')
    this.swiperWrapper = this.element.querySelector('.swiper-wrapper')
    this.swiperButtonPrev = this.element.querySelector('[data-component="slider-prev-btn"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="slider-next-btn"]')
    this.reviews = this.element.querySelectorAll('.swiper-slide .review')
    this.mediaQuery = window.matchMedia('(min-width: 1024px)')

    const reviewsSlider = new Swiper(this.swiperElement, {
      loop: false,
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 30,
      autoHeight: false,
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
    })

    this.reviews.forEach((review) => {
      const hiddenText = review.querySelector('.hidden-text')
      const moreBtn = review.querySelector('.more-button .more')
      const lessBtn = review.querySelector('.more-button .less')
      if (moreBtn) {
        moreBtn.addEventListener('click', () => {
          this.swiperWrapper.style.height = 'auto'
          this.hideHiddenText(this.reviews)
          review.classList.add('show-hidden-text')
        })
      }
      if (lessBtn) {
        lessBtn.addEventListener('click', () => {
          this.hideHiddenText(this.reviews)
          reviewsSlider.updateAutoHeight()
          if (!document.body.classList.contains('single-treatment')) {
            if (this.mediaQuery.matches) {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 78 }, ease: "power4" });
            } else {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 124 }, ease: "power4" });
            }
          } else {
            if (this.mediaQuery.matches) {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 149 }, ease: "power4" });
            } else {
              gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 194 }, ease: "power4" });
            }
          }
        })
      }
    })

    reviewsSlider.on('slideChange', () => {
      if (!document.body.classList.contains('single-treatment')) {
        if (this.mediaQuery.matches) {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 78 }, ease: "power4" });
        } else {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 124 }, ease: "power4" });
        }
      } else {
        if (this.mediaQuery.matches) {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 149 }, ease: "power4" });
        } else {
          gsap.to(window, { duration: 1, scrollTo: { y: this.element, offsetY: 194 }, ease: "power4" });
        }
      }
      this.hideHiddenText(this.reviews)
    })
  }

  hideHiddenText (reviews) {
    this.reviews.forEach((review) => {
      review.classList.remove('show-hidden-text')
    })
  }

}
